module.exports = __webpack_public_path__ + "img/community-banner.58fc2a8c.svg";